import { TFunction } from 'i18next';
import useGridCustomCell from '@components-clean/core/grid/custom-cell';
import { DateTimeCell } from '@components-clean/core/grid-fe/custom-cells';
import { GridColumnProps } from '@components-clean/core/grid-fe/grid.interface';

const { TooltipCell } = useGridCustomCell();

export function getRiskReviewsColumns(t: TFunction<'translation', undefined>): GridColumnProps[] {
    return [
        {
            id: 'status',
            field: 'status',
            title: t('ra:status'),
            lockedByDefault: true,
            minWidth: 120,
            width: 1,
            filter: 'text',
        },
        {
            id: 'description',
            field: 'description',
            title: t('ra:description'),
            lockedByDefault: true,
            minWidth: 200,
            width: 1,
            filter: 'text',
            cells: {
                data: TooltipCell({
                    isCsv: false,
                }),
            },
        },
        {
            id: 'attendees',
            field: '_attendeesDisplay',
            title: t('ra:attendees'),
            minWidth: 300,
            width: 1,
            filter: 'text',
            cells: {
                data: TooltipCell({
                    isCsv: true,
                    lovArrayField: '_attendees',
                }),
            },
        },
        {
            id: 'startDate',
            field: 'startDate',
            title: t('ra:startDate'),
            minWidth: 100,
            width: 1,
            filter: 'date',
            cells: { data: DateTimeCell('DD-MMM-yyyy') },
            cellName: 'DateCell',
        },
        {
            id: 'endDate',
            field: 'endDate',
            title: t('ra:endDate'),
            minWidth: 100,
            width: 1,
            filter: 'date',
            cells: { data: DateTimeCell('DD-MMM-yyyy') },
            cellName: 'DateCell',
        },
        {
            id: 'comments',
            field: 'comments',
            title: t('ra:comments'),
            minWidth: 300,
            width: 1,
            filter: 'text',
            cells: {
                data: TooltipCell({
                    isCsv: false,
                }),
            },
        },
        {
            id: 'protocolVersion',
            field: 'protocolVersion',
            title: t('ra:protocolVersion'),
            minWidth: 200,
            width: 1,
            filter: 'text',
            cells: {
                data: TooltipCell({
                    isCsv: false,
                }),
            },
        },
        {
            id: 'createdByName',
            field: 'createdByName',
            title: t('ra:createdBy'),
            showByDefault: false,
            minWidth: 125,
            width: 1,
            filter: 'text',
        },
        {
            id: 'createdDate',
            field: 'createdDate',
            title: t('ra:createdDate'),
            minWidth: 100,
            width: 1,
            showByDefault: false,
            filter: 'date',
            cells: { data: DateTimeCell('DD-MMM-yyyy') },
            cellName: 'DateCell',
        },
        {
            id: 'updatedByName',
            field: 'updatedByName',
            title: t('ra:updatedBy'),
            minWidth: 125,
            width: 1,
            filter: 'text',
        },
        {
            id: 'updatedDate',
            field: 'updatedDate',
            title: t('ra:updatedDate'),
            minWidth: 100,
            width: 1,
            filter: 'date',
            cells: { data: DateTimeCell('DD-MMM-yyyy') },
            cellName: 'DateCell',
        },
        {
            id: 'id',
            minWidth: 100,
            width: 1,
            field: '_itemId',
            showByDefault: false,
            title: t('id'),
        },
    ];
}
